import {Component, OnInit} from '@angular/core';
import {IndividualAccidentsOffer} from '../../../model/IndividualAccidents';
import {IndividualAccidentsService} from '../../../services/individual-accidents.service';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Response, StaticMethods} from '../../../model/GeneralModels';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ]
})
export class OfferComponent implements OnInit {
  durations: string[] = [];
  offers: IndividualAccidentsOffer[] = [];
  private viewList: any = {};
  private formsData: any = {};
  public translation: any = {};
  private selectedOffer: IndividualAccidentsOffer;
  offerDuration: IndividualAccidentsOffer[] = [];

  durationFormControl = new FormControl('', Validators.required);
  offerID = new FormControl('', Validators.required);

  formGroup = this.fb.group({
    duration: this.durationFormControl,
    offerID: this.offerID
  });

  constructor(private service: IndividualAccidentsService,
              private settings: AppSettingsService,
              private router: Router,
              private fb: FormBuilder,
              public appSettingsService: AppSettingsService
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['viewList', 'formsData', 'translation'], '/individual-accidents/basic-information')) {
      this.formsData = history.state.formsData;
      this.translation = history.state.translation;
      this.viewList = history.state.viewList;
      this.service.getOffers(this.formsData.companyID).subscribe((response: Response) => {
        if (response.success) {
          console.log(response);
          this.offers = [];
          this.durations = response.data.durations;
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          console.log(this.durations[0]);
          this.durationFormControl.patchValue(this.durations[this.durations.length - 1]);
          response.data.offers.forEach(offer => {
            this.offers.push(new IndividualAccidentsOffer(offer, this.durations));
          });
          this.setOfferDurationList();
        }
      });
    }
  }

  generateViewList() {
    if (this.formGroup.valid) {
      this.viewList.duration = this.durationFormControl.value;
      this.viewList.companyName = this.selectedOffer.companyName;
      this.viewList.offerName = this.selectedOffer.offerName;
      this.formsData.duration = this.durationFormControl.value;
      this.formsData.offerID = this.offerID.value;
      return {
        viewList: this.viewList,
        formsData: this.formsData,
        translation: this.translation
      };
    }
  }

  submit() {
    if (this.formGroup.valid) {
      const state = this.generateViewList();
      console.log(state);
      this.router.navigate(['/individual-accidents/confirm'], {
        state
      });
    }
  }

  onSelectionChange(offer: IndividualAccidentsOffer) {
    this.changeSelectedPanel(offer.id);
    this.selectedOffer = offer;
    this.formGroup.controls.offerID.patchValue(offer.id);
  }

  changeSelectedPanel(offerID) {
    let element;
    if (this.formGroup.controls.offerID.valid) {
      element = document.getElementById(this.formGroup.controls.offerID.value + '');
      element.style.display = 'none';
      console.log(element);
    }
    element = document.getElementById(offerID + '');
    element.style.display = 'block';
    console.log(element);
    this.formGroup.controls.offerID.patchValue(offerID);
  }

  getCurrency(cost: number) {
    return StaticMethods.numberWithCommas(cost);
  }

  setOfferDurationList() {
    const selectedDuration = this.formGroup.controls.duration.value;
    this.offerDuration = [];
    this.offerDuration = this.offers.filter(offer => {
      return !(!offer.costs[selectedDuration]);
    });
  }
}
